import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';

import { url } from "../Constent/Constant";

const Service = ({ GetData, UpdateImage, UpdateText }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [UpdateId, setUpdateId] = useState('')

    const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setUpdateId(id)
    };

    const showImageModal = (id) => {
        setImageModal(true);
        setUpdateId(id)
    };


    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: UpdateId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: UpdateId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if (event.key === 'Enter') {
            console.log('Enter Clicked')
            a.concat('\n')
            setHeadingUpdate(a)
        } else {
            console.log(event.key)
        }
    }


    return (
        <div className='Service'>
            <p className='Subheading'> {GetData.section3subheading1.content}
                <i onClick={() => ShowTextModal(GetData.section3subheading1._id)} className="far fa-edit Edit-btn"></i>
            </p>
            <h2 className='Heading'> {GetData.section3heading1.content}
                <i onClick={() => ShowTextModal(GetData.section3heading1._id)} className="far fa-edit Edit-btn"></i>
            </h2>
            <div className='Service-container'>
                <div className='Service-Card'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(GetData.section3image1._id)} className="far fa-edit Edit-btn"></i>
                        <img draggable={false} src={`${url}/api/getFile${GetData.section3image1.image}`} alt='Icon' />
                    </div>
                    <h3>{GetData.section3heading2.content}
                        <i onClick={() => ShowTextModal(GetData.section3heading2._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(GetData.section3paragraph1._id)} className="far fa-edit Edit-btn"></i>
                        <p> {GetData.section3paragraph1.content} </p>
                    </div>
                </div>
                <div className='Service-Card'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(GetData.section3image2._id)} className="far fa-edit Edit-btn"></i>
                        <img draggable={false} src={`${url}/api/getFile${GetData.section3image2.image}`} alt='Icon' />
                    </div>
                    <h3> {GetData.section3heading3.content}
                        <i onClick={() => ShowTextModal(GetData.section3heading3._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(GetData.section3paragraph2._id)} className="far fa-edit Edit-btn"></i>
                        <p> {GetData.section3paragraph2.content} </p>
                    </div>
                </div>
                <div className='Service-Card'>
                    <div className='Image-div'>
                        <i onClick={() => showImageModal(GetData.section3image3._id)} className="far fa-edit Edit-btn"></i>
                        <img draggable={false} src={`${url}/api/getFile${GetData.section3image3.image}`} alt='Icon' />
                    </div>
                    <h3> {GetData.section3heading4.content}
                        <i onClick={() => ShowTextModal(GetData.section3heading4._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(GetData.section3paragraph3._id)} className="far fa-edit Edit-btn"></i>
                        <p> {GetData.section3paragraph3.content} </p>
                    </div>
                </div>
            </div>

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>

        </div>
    )
}

export default Service
